//@ts-nocheck
import styles from './String.module.scss'

import { IStringInputSettings, Status } from '../inputs.interface'
import Badge from './components/Badge'
import useString from './hooks/useString'
import { IInputStatus } from '../../../interface/progress.interface'

import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import Tooltip from '../../../assets/icons/tooltip.svg'

interface Props {
  value: string
  name: string
  status: IInputStatus
  disabled: boolean
  apiErrors: {
    [name: string]: string
  }
  innerRef: React.RefObject<HTMLInputElement>
  handleChange: React.ChangeEventHandler<HTMLInputElement>
  handleKeydown: React.KeyboardEventHandler<HTMLInputElement>
  handlePaste: React.ClipboardEventHandler<HTMLInputElement>
  handleFocus: React.FocusEventHandler<HTMLInputElement>
  handleBlur: React.FocusEventHandler<HTMLInputElement>
  settings: IStringInputSettings
  dependenciesValue?: string | null
  width?: string
  inputType?: string
  substitution?: string
  isSuccessClass?: boolean
  tooltip?: string
  badgeOptions?: {
    isSuccessBadge?: boolean
    isBadge?: boolean
    isPercentBadge?: boolean
  }
}

const String = ({
  value,
  name,
  status,
  disabled,
  apiErrors,
  innerRef,
  handleChange,
  handleKeydown,
  handlePaste,
  handleFocus,
  handleBlur,
  settings,
  dependenciesValue,
  width = '100%',
  inputType,
  substitution,
  isSuccessClass = true,
  tooltip,
  badgeOptions = {
    isSuccessBadge: true,
    isBadge: true,
    isPercentBadge: true,
  }
}: Props) => {
  const { placeholder, label, description, emptyErrorText, notValidErrorText } =
    settings
  const { id, contentRef, labelRef } = useString(
    innerRef,
    settings,
    status,
    styles,
    dependenciesValue
  )
  console.log(name, value, status)
  const style =
    (document.documentElement.clientWidth || document.body.clientWidth) > 790
      ? { width: width }
      : {}
  const inputClass =
    `${status !== IInputStatus.error ? styles.input_wrapper : styles.input_error} `
    + `${(!!substitution || !!value) ? styles.close : ''} `
    + `${isSuccessClass && status === IInputStatus.success ? styles.input_success : ''}`

  const inputInClass = `${styles.input} `
    + `${value ? styles.inputFull : ''} `
    + `${!!substitution ? styles.input_substitution : ''} `
    + `${status === IInputStatus.error ? styles.input_in_error : ''}`

  return (
    <div className={styles.wrapper} style={style}>
      <div className={styles.content} ref={contentRef}>
        <div className={inputClass}>
          {
            !!substitution &&
            <span>
              {substitution}
            </span>
          }
          {/* {
            (!!substitution || !!value) &&
            <span>
              {substitution}
            </span>
          } */}
          <input
            className={inputInClass}
            value={value}
            placeholder={placeholder}
            disabled={status === IInputStatus.notActive ? true : false}
            required={!value}
            ref={innerRef}
            type={ 'text'}
            id={id}
            onChange={handleChange}
            onKeyDown={handleKeydown}
            onPaste={handlePaste}
            onFocus={handleFocus}
            onBlur={handleBlur}

          />
          <label className={`${styles.label} `
            + `${status === IInputStatus.error || status === IInputStatus.apiError ? styles.label_error : ''}`}
            htmlFor={id}
            ref={labelRef}
          >
            {label}
          </label>
          {badgeOptions.isBadge && !disabled &&
            <Badge
              status={status}
              badge={settings.badge}
              isPercentBadge={badgeOptions.isPercentBadge}
              isSuccessBadge={badgeOptions.isSuccessBadge}
            />}
        </div>
        {
          tooltip &&
          <div className={styles.tooltip}>
            <Tippy content={tooltip}>
              <img src={Tooltip} alt='help' className={style.tooltip_img} />
            </Tippy>
          </div>
        }
      </div>
      {
        status !== IInputStatus.error && status !== IInputStatus.apiError &&
        description && <div className={styles.description}>{description}</div>
      }
      {status === IInputStatus.error && value !== '' && (
        <div className={styles.message_error}>{notValidErrorText}</div>
      )}
      {status === IInputStatus.error && value === '' && (
        <div className={styles.message_error}>{emptyErrorText}</div>
      )}
      {status === IInputStatus.apiError && apiErrors[name] && (
        <div className={styles.message_error}>{apiErrors[name].msg || apiErrors[name][0]}</div>
      )}
    </div>
  )
}

export default String
